// extracted by mini-css-extract-plugin
module.exports =  {"static-desc":"textDashboardItem__static-desc","last-link":"textDashboardItem__last-link"};